import { CHECKOUT3_ADDON_DATA,CHECKOUT3_ADDON_DATA_CLEAR } from "../../constantTypes/checkout3/addonContstantTypes";


export const AddonReducer=(state=[],action)=> {
    let payload=action.payload|| undefined;
    if(payload===undefined || payload===null || payload===0){
        payload={addons:[]};
    }
    switch (action.type) {
        case CHECKOUT3_ADDON_DATA:
       
            return {   ...state,addons:payload}
        case CHECKOUT3_ADDON_DATA_CLEAR:
       
                return {   ...state,addons:{}}   
               
              
        default: return state;
            
    }
}